import { isNavigationFailure, router } from "@/js/routes"
import { useStore } from '../stores/index'
import { useUserStore } from '../stores/user'
import userAxios from "./axios"

// Redirect the user to entrance
export async function redirectToEntrance(params: {urlHash?: string} = { urlHash: null })
{
	const store = useStore()
	const userStore = useUserStore()

	userStore.loggedIn = false // Log out UI, otherwise we cannot redirect to sign in page
	
	// Actually redirecting
	try{
		const hash = params?.urlHash ? "#" + params?.urlHash : ''

		return await router.push({
			name: 'sign-in',
			params: {
				language: store.currentLanguage,
			},
			hash
		})
	} catch (failure) {
		if (isNavigationFailure(failure)) {
			console.log("Stopped navigating from " + failure.from.path + " to " + failure.to.path)
		}
	}
}

export async function logout(params: { urlHash?: string } = {})
{
	const store = useStore()
	
	store.loaderContent = "default"
			
	await userAxios.get('/api/user-side/logoutUser')

	// This timeout is needed to wait for all route transitions to complete
	setTimeout(() => store.loaderContent = false, 1000)

	return redirectToEntrance(params)
}